import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lightbox", "lightboxImage", "counter"]
  static values = { urls: Array, index: { type: Number, default: 0 } }

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
  }

  open({ params: { index } }) {
    this.indexValue = index
    this.lightboxTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    this.updateDisplay()
  }

  close() {
    this.lightboxTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  prev() {
    this.indexValue = (this.indexValue - 1 + this.urlsValue.length) % this.urlsValue.length
    this.updateDisplay()
  }

  next() {
    this.indexValue = (this.indexValue + 1) % this.urlsValue.length
    this.updateDisplay()
  }

  backdropClick(event) {
    if (event.target === event.currentTarget) this.close()
  }

  handleKeydown(e) {
    if (this.lightboxTarget.classList.contains("hidden")) return
    if (e.key === "Escape") this.close()
    if (e.key === "ArrowLeft") this.prev()
    if (e.key === "ArrowRight") this.next()
  }

  updateDisplay() {
    this.lightboxImageTarget.src = this.urlsValue[this.indexValue]
    this.counterTarget.textContent = `${this.indexValue + 1} / ${this.urlsValue.length}`
  }
}
